import React from "react";
import { Container } from "../../../../components";
import classnames from "classnames";
import Pages from "../../../../../../constants/pages";
import TEXT from "../../../text-consts";
import BackLink from "../../atoms/BackLink/BackLink";
import CustomerContinueButton from "../../organisms/CustomerContinueButton/CustomerContinueButton";
import { isBankIdVerified } from "../../../../authentication/state/selectors";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../models";
import { TELIA_PLAY_LINKS } from "../../../../../../constants";
import { getSelectedPackageId } from "../../../state/selectors";
import { getPackageSlugFromId } from "../../../../../../shared/teliaPlayPackageMapping";
import SummaryContinueButton from "../../organisms/SummaryContinueButton/SummaryContinueButton";

const matchesPage = (path: string, pagePath: string) => {
    const basePath = pagePath.replace(/\/+$/, "");
    return path === basePath || path.startsWith(`${basePath}/`);
};

interface ContinueButtonProps {
    path: string;
}

const ContinueButton: React.FC<ContinueButtonProps> = ({ path }) => {
    const bankIdVerified = useSelector((state: RootState) => isBankIdVerified(state));
    const customerPath = Pages.TELIA_PLAY.CUSTOMER.URL;
    if (matchesPage(path, customerPath)) {
        return bankIdVerified ? <CustomerContinueButton /> : null;
    } else {
        return <SummaryContinueButton />;
    }
};

interface BackButtonProps {
    path: string;
}

const BackButton: React.FC<BackButtonProps> = ({ path = "" }) => {
    const selectedPackageId = useSelector((state: RootState) => getSelectedPackageId(state));
    const requestedPackageId = useSelector((state: RootState) => state.teliaPlay?.requestedPackageId);
    const packageSlug = getPackageSlugFromId(selectedPackageId ?? requestedPackageId);
    let href = "";
    let text = TEXT.BUTTON.BACK;
    const currentIndex = TELIA_PLAY_LINKS.findIndex((link) => matchesPage(path, link));

    if (matchesPage(path, Pages.TELIA_PLAY.RECEIPT.URL)) {
        href = "https://www.telia.no/";
        text = TEXT.BUTTON.TELIANO_PAGE;
    } else if (matchesPage(path, Pages.TELIA_PLAY.SUMMARY.URL)) {
        if (packageSlug) {
            href = `${Pages.TELIA_PLAY.CUSTOMER.URL}${encodeURIComponent(packageSlug)}/`;
        }
    } else if (currentIndex > 0) {
        href = TELIA_PLAY_LINKS[currentIndex - 1];
    }

    return <BackLink path={path} href={href} text={text} />;
};

interface ContinueSectionProps {
    className?: string;
    path: string;
}

const ContinueSection: React.FC<ContinueSectionProps> = ({ className = "", path }) => (
    <Container
        className={classnames("telia-play-page--space-between", {
            "telia-play-summary-actions": matchesPage(path, Pages.TELIA_PLAY.SUMMARY.URL),
            [className]: className,
        })}
        size="small"
        noMargin
    >
        <BackButton path={path} />
        <div className="telia-play-page__continue-button-container">
            <ContinueButton path={path} />
        </div>
    </Container>
);

export default ContinueSection;
